import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  aifm_jurisdiction: {
    type: 'customText',
    name: 'The country of jurisdiction of your national regulator',
    order: 1,
    letter: 'A'
  },
  aifm_national_code: {
    type: 'customText',
    name: "Your national regulator's code for you as a business entity (FRN)",
    order: 3,
    disabled: true,
    letter: 'A'
  },
  aifm_name: {
    type: 'customText',
    name: 'Your company name',
    order: 4,
    letter: 'A'
  },
  aifm_identifier_bic: {
    type: 'customText',
    name: 'Your Business Identification Code (BIC)',
    order: 5,
    letter: 'A'
  },
  aifm_identifier_lei: {
    type: 'customText',
    name: 'You Legal Entity Identification code (LEI)',
    order: 6,
    letter: 'A'
  },
  aifm_reporting_code: {
    type: 'customText',
    name: 'Your registration status',
    order: 7,
    letter: 'A'
  },
  filing_type: {
    type: 'customText',
    name: 'Type of filing',
    order: 10,
    required: true,
    letter: 'A'
  },
  aifm_content_type: {
    type: 'customText',
    name: 'Filing content',
    order: 11,
    letter: 'A'
  },
  aifm_reporting_obligation_change_frequency_code: {
    type: 'customText',
    name: 'Frequency change code',
    order: 12,
    required: true,
    letter: 'A'
  },
  aifm_reporting_obligation_change_contents_code: {
    type: 'customText',
    name: 'Contents change code	',
    order: 13,
    required: true,
    letter: 'A'
  },
  aifm_reporting_obligation_change_quarter: {
    type: 'customNumber',
    name: 'First quarter in which a change occurred',
    order: 14,
    required: true,
    letter: 'A'
  },
  last_reporting_flag: {
    type: 'customText',
    name: 'Is this the last report you will make?',
    order: 15,
    required: true,
    letter: 'A'
  },
  reporting_period_type: {
    type: 'customText',
    name: 'Reporting period',
    order: 16,
    required: true,
    letter: 'A'
  },
  reporting_period_start_date: {
    type: 'customText',
    name: 'Start date',
    order: 17,
    required: true,
    letter: 'A'
  },
  reporting_period_end_date: {
    type: 'customText',
    name: 'End date',
    order: 18,
    letter: 'A'
  },
  reporting_period_year: {
    type: 'customText',
    name: 'Year',
    order: 19,
    letter: 'A'
  },
  aifm_no_reporting_flag: {
    type: 'customText',
    name: "Do you wish to submit a nil return? (Answer 'Yes' if you do not have any information to report on AIFs)",
    order: 20,
    letter: 'A'
  }
};

export const FundIdentificationCodesAIF001 = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.MAIN_INFO,
    onChangeFund,
    schema: schema.MAIN_INFO,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MAIN_INFO?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'MAIN_INFO'
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.MAIN_INFO?.field_names?.length === 0;

  const errors = funds[currentDataKey]?.fund_data?.MAIN_INFO?.find(item => item?.errors?.general)
    ?.errors?.general as any;

  return (
    <>
      <Errors id="fca-reporttables-fund-identification-codes-aif001-errors">
        {isRequiredTable && (
          <li id="fca-reporttables-fund-identification-codes-aif001-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map(item => (
          <li
            key={item.msg}
            id={`fca-reporttables-fund-identification-codes-aif001-error-${item.msg}`}
          >
            {item.msg}
          </li>
        ))}
      </Errors>

      <Table
        id="fca-reporttables-fund-identification-codes-aif001-table"
        stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        handleChanges={onChange}
        columns={columns}
        rows={rows}
      />
    </>
  );
};
